// TODO(RBAC, parent #641 #647): admin only
import { createConnectQueryKey } from '@connectrpc/connect-query'
import { listWorkflowTagPool } from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'
import {
  createWorkflowTemplate,
  getWorkflowTemplateFormOptions,
  listWorkflowTemplates,
} from '@ebalance/proto/bffuser/v1/workflow_template_service-WorkflowTemplateService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * ワークフロー雛形作成 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 * タグプール (AC-TAG-005) も invalidate する — default_tags の新規タグが
 * org 全体のプールに加わりうるため、他画面のサジェスト・20 個上限チェックを
 * 最新化する。
 * workflow-template-form-options-bff-aggregation design: editor 自身が使う
 * 集約 query (`getWorkflowTemplateFormOptions`) の tag_pool 投影も同じ理由で
 * invalidate する (旧 `listWorkflowTagPool` key は他画面 consumer が使うため
 * 残置し、新 key を追加する)。
 */
export function useCreateWorkflowTemplate(): InvalidatingMutationResultFor<
  typeof createWorkflowTemplate
> {
  return useInvalidatingMutation(createWorkflowTemplate, [
    createConnectQueryKey({
      schema: listWorkflowTemplates,
      cardinality: 'finite',
    }),
    createConnectQueryKey({
      schema: listWorkflowTagPool,
      cardinality: 'finite',
    }),
    createConnectQueryKey({
      schema: getWorkflowTemplateFormOptions,
      cardinality: 'finite',
    }),
  ])
}
